define("ember-changeset/utils/is-object", ["exports", "@ember/array"], function (_exports, _array) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = isObject;
  0; //eaimeta@70e063a35619d71f0,"@ember/array"eaimeta@70e063a35619d71f
  /**
   * Employ Ember strategies for isObject detection
   * @method isObject
   */
  function isObject(val) {
    return val !== null && typeof val === 'object' && !(val instanceof Date || val instanceof RegExp) && !(0, _array.isArray)(val);
  }
});